import React, { useEffect, useRef, useState } from "react";

import MachineEngClassic from "./TableView/MachineEngTable.jsx/MachineEngClassic";
import MachineEngCustomTable from "./TableView/MachineEngTable.jsx/MachineEngCustomTable";
import ComparativeReportMaster from "./TableView/MachineEngTable.jsx/ComparativeReport/ComparativeReportMaster";
const reports = ["Details of Machine Progress", "Comparative Machine report"];
const MachineMaster = ({ customReport, data, date, startFetch }) => {
  const [activeReport, setActiveReport] = useState(
    "Details of Machine Progress",
  );

  return (
    <div>
      <div className="">
        <div className="d-flex justify-content-center">
          {reports.map((btn, i) => (
            <button
              key={i}
              className={`btn btn-sm btn-outline-dark m-1 ${activeReport === btn && "active"}`}
              onClick={() => {
                setActiveReport(btn);
              }}
            >
              {btn}
            </button>
          ))}
          <></>
        </div>
        {activeReport === "Details of Machine Progress" && (
          <MachineEngCustomTable data={data} />
          // <MachineEngClassic />
        )}{" "}
        {activeReport === "Comparative Machine report" && (
          <ComparativeReportMaster date={date} startFetch={startFetch} />
        )}
      </div>
    </div>
  );
};
export default MachineMaster;
